import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import InputField from "../../../../Components/Masters/InputField";
import { Box, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { get, put } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import RadioButtons from "../../../../Components/Common/RadioButtons";

import ReviewBox from "../../../../Components/Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";

const GRI207_1 = ({ hide }) => {
  const [griReview, setGriReview] = useState(() =>
    JSON.parse(localStorage.getItem("griReview"))
  );
  const questionData = [
    {
      fieldName: "taxStrategyApprovalBody",
      title:
        "b. Which governance body or executive-level position within the organization formally reviews and approves the tax strategy, and how often is this review conducted?",
      type: "text",
      placeholder: "Enter Text",
    },
    {
      fieldName: "regulatoryComplianceApproach",
      title:
        "c. Describe the organization's approach to regulatory compliance, including any statements in the tax strategy regarding its intention with respect to tax laws in the jurisdictions where it operates. Specifically, does the organization seek to comply with the letter and the spirit of the law, taking reasonable steps to determine and follow the intention of the legislature?",
      type: "text",
      placeholder: "Enter Text",
    },
    {
      fieldName: "taxAlignmentWithBusinessAndSustainability",
      title:
        "d. How is the organization's approach to tax linked to its business and sustainable development strategies? Explain how its tax planning aligns with its commercial activities and any relevant statements from its tax strategy regarding alignment with sustainable development commitments in the jurisdictions where it operates, including consideration of economic and social impacts.",
      type: "text",
      placeholder: "Enter Text",
    },
  ];

  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});
  const [formData, setFormData] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(`/gri/get?Id=${id}&type=GRI200`);
      const res1 = res?.data?.data?.GRI200?.apporachToTax;
      if (
        res?.data?.data?.year ? res?.data?.data?.year < currentYear - 1 : false
      )
        setDisabled(true);
      setData(res1);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (data)
      setFormData({
        taxStrategySummary: data?.taxStrategySummary || {
          status: true,
          remarks: "",
        },
        taxStrategyApprovalBody: data?.taxStrategyApprovalBody || "",
        regulatoryComplianceApproach: data?.regulatoryComplianceApproach || "",
        taxAlignmentWithBusinessAndSustainability:
          data?.taxAlignmentWithBusinessAndSustainability || "",
      });
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    if (name === "remarks") {
      setFormData((prev) => ({
        ...prev,
        taxStrategySummary: { ...prev.taxStrategySummary, remarks: value },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (
      formData?.taxStrategySummary?.status &&
      formData?.taxStrategySummary?.remarks === ""
    )
      newErrors["remarks"] = "This field is Required";
    // questionData.forEach((el) => {
    //   if (!formData[el.fieldName] || formData[el.fieldName].trim() === "") {
    //     newErrors[el.fieldName] = "This field is Required";
    //   }
    // });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      if (!validateForm()) return;

      let transformedData2 = {
        apporachToTax: formData,
        type: "GRI200",
        submitted207_1: true,
      };

      try {
        const res = await put(`/gri/update?Id=${id}`, transformedData2);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        navigate(`/gri/economic-performance/207-2/${id}`);
      } catch (error) {
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/economic-performance/207-2/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      {/* <Box sx={{ display: "flex" }}> */}
      {!hide && (
        <p
          className={styles.section_heading}
          style={{ marginBottom: hide ? "-1rem" : "0" }}
        >
          207 : Tax 2019
        </p>
      )}
      <p className={styles.main_heading}>207-1 : Approach to tax</p>
      {/* a */}
      <p
        className={styles.ques_heading}
        style={{ textIndent: "-1rem", marginTop: hide ? "-1rem" : "2rem" }}
      >
        a. Does the organization have a tax strategy, and if so, can you provide
        a summary or abstract of this strategy if it's not publicly available?
        Additionally, if the strategy applies to a smaller number of entities or
        tax jurisdictions than reported, please list the entities or tax
        jurisdictions to which it applies.
      </p>
      <Box sx={{ mt: hide ? "-2rem" : "-1rem" }}>
        <RadioButtons
          value={formData?.taxStrategySummary?.status || false}
          handleChange={(e) => {
            const value = e.target.value === "true"; // Convert string to boolean
            setFormData((prev) => ({
              ...prev,
              taxStrategySummary: {
                ...prev.taxStrategySummary,
                status: value,
              },
            }));
            setErrors((prev) => ({
              ...prev,
              remarks: "",
            }));
          }}
          disabled={disabled}
        />
      </Box>
      {formData?.taxStrategySummary?.status && (
        <Box sx={{ ml: 2, mt: hide ? "-1rem" : "0.5rem" }}>
          <InputField
            placeholder={"Enter Text"}
            fieldName={"remarks"}
            value={formData?.taxStrategySummary?.remarks}
            handleChange={handleChange}
            mt="-5px"
            errors={errors["remarks"] && true}
            disabled={disabled}
          />
          <p
            color="error"
            variant="caption"
            style={{
              lineHeight: "1.2",
              margin: "2px 0",
              marginTop: "5px",
              color: "#d34040",
              fontSize: "10px",
              fontStyle: "italic",
            }}
          >
            {errors["remarks"]}
          </p>
        </Box>
      )}
      {questionData.map((el) => (
        <Box sx={{ mt: 2 }}>
          <p
            className={styles.ques_heading}
            style={{
              textIndent: "-1rem",
              marginTop: hide ? "-1rem" : "0.5rem",
            }}
          >
            {el.title}
          </p>
          <Box sx={{ ml: 2.2 }}>
            <InputField
              placeholder={"Enter Text"}
              fieldName={el.fieldName}
              value={formData?.[el.fieldName]}
              handleChange={handleChange}
              mt="-5px"
              errors={errors[el.fieldName] && true}
              disabled={disabled}
            />
            <p
              color="error"
              variant="caption"
              style={{
                lineHeight: "1.2",
                margin: "2px 0",
                marginTop: "5px",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
              }}
            >
              {errors[el.fieldName]}
            </p>
          </Box>
        </Box>
      ))}
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI207_1;
